import { createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

export const CreateCampaign = createAsyncThunk(
  "createcampaign",
  async ({ audienceType, message, days }, thunkAPI) => {
    const accessToken = sessionStorage.getItem("token");

    // Dynamically build request body
    const body = {
      audienceType,
      message,
      ...(days !== null && { days }) // Only include 'days' if it's not null
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}campaign/send`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          },
          body: JSON.stringify(body)
        }
      );

      const data = await response.json();

      if (!data?.status) {
        toast.error(data.message);
      }

      return data;
    } catch (e) {
      return thunkAPI.rejectWithValue({
        error: "Failed! To establish connection."
      });
    }
  }
);
